import appealsRoutes from "@/apps/appeals/router";
import contactsRoutes from "@/apps/contacts/router";
import newsRoutes from "@/apps/news/router";
import UserSettingsRoutes from "@/apps/user/router";
import AuthRoutes from "@/apps/auth/router";
import CountersRoutes from "@/apps/counters/router";
import PaymentsRoutes from "@/apps/payments/router";
import MainPageRoutes from "@/apps/main/router";

export default [
  {
    path: '/',
    redirect: '/payments',
    name: 'Home'
  },
  AuthRoutes,
  appealsRoutes,
  contactsRoutes,
  newsRoutes,
  UserSettingsRoutes,
  CountersRoutes,
  PaymentsRoutes,
  MainPageRoutes,
  {
    path: "*",
    name: "PageNotFound",
    redirect: "/"
  }
];
